import type { SystemGroup } from '@/types/systems';

export const generateUrl = (group: SystemGroup) => `/systems/group/${group._id}`;
